import { Check } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { SectionHeading } from "../ui/SectionHeading";
import { DownloadCTA } from "../ui/DownloadCTA";
import { ALL_PERKS } from "../../content/site";

function PerkList({ perks }: { perks: string[] }) {
  return (
    <ul className="mt-6 grid gap-3 sm:grid-cols-2">
      {perks.map((perk) => (
        <li key={perk} className="flex items-start gap-3">
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-navy bg-sun text-navy">
            <Check className="h-3 w-3" strokeWidth={3.5} />
          </span>
          <span className="text-sm leading-relaxed text-white/85">{perk}</span>
        </li>
      ))}
    </ul>
  );
}

export function Pricing() {
  return (
    <section id="pricing" className="relative py-20 sm:py-28 bg-cream">
      <div className="container-x">
        <SectionHeading
          eyebrow="Pricing"
          title={
            <>
              Totally free. <span className="marker">Everything in.</span>
            </>
          }
          sub="FitBuddy is free to use, with every feature included. No subscription, no card, nothing locked away."
        />

        <div className="mx-auto mt-14 max-w-2xl">
          <Reveal>
            <div className="relative flex flex-col rounded-[1.75rem] border-[3px] border-navy bg-navy p-7 shadow-pop-sun sm:p-10">
              <span className="sticker absolute -right-3 -top-5 rotate-6">
                100% free
              </span>

              <div className="flex items-center justify-between">
                <h3 className="font-display text-xl font-extrabold text-white">
                  FitBuddy
                </h3>
                <span className="chip">All included</span>
              </div>

              <div className="mt-4 flex flex-wrap items-baseline gap-2">
                <span className="num display text-6xl text-white">£0</span>
                <span className="font-mono text-sm text-white/60">free</span>
              </div>
              <p className="mt-2 text-sm text-white/70">
                Free to use. No subscription, no card needed.
              </p>

              <PerkList perks={ALL_PERKS} />

              <div className="mt-auto pt-10">
                <DownloadCTA source="pricing" showBadges={false} tone="onColor" />
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={1}>
          <p className="mx-auto mt-10 max-w-xl text-center text-xs leading-relaxed text-charcoal/60">
            Every weigh-in, stream and feature is included at no cost.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
